import React from 'react';
import {
  Switch,
  Route,
  Redirect,
} from 'react-router-dom';
import { components } from '@seaoil/component-lib';

// pages
import Home from './pages/Home';
import Login from './pages/Login';
import Session from './pages/Session';
import ViewFile from './pages/ViewFile';
import Workflow from './pages/Workflow';
import WorkflowExec from './pages/WorkflowExec';
import ExpensePaymentRequest from './pages/ExpensePaymentRequest';
import InvokeMigrate from './pages/InvokeMigrate';
import NotFound from './pages/NotFound';
import TaskRespond from './pages/Task/Respond';
import TaskRespondRemarks from './pages/Task/RespondWithRemarks';
import ApiKey from './pages/Account/ApiKey';

// css
import '@seaoil/component-lib/dist/index.css';

const { Auth, Theme } = components;

function App() {
  return (
    <Auth.Provider>
      <Theme.Provider>
        <Switch>
          <Route exact path="/">
            <Redirect to="/welcome" />
          </Route>
          <Route path="/welcome" component={Home} />
          <Route path="/login" component={Login} />
          <Route path="/session" component={Session} />
          <Route path="/invoke" component={InvokeMigrate} />
          <Route path="/view-file" component={ViewFile} />
          <Route exact path="/workflow" component={Workflow} />
          <Route path="/workflow/expense-payment-request" component={ExpensePaymentRequest} />
          <Route path="/workflow/task/respond" component={TaskRespond} />
          <Route path="/workflow/task/respond-with-remarks" component={TaskRespondRemarks} />
          <Route path="/workflow/execution/:execArn" component={WorkflowExec} />
          <Route path="/account/generate-api-key" component={ApiKey} />
          <Route component={NotFound} />
        </Switch>
      </Theme.Provider>
    </Auth.Provider>
  );
}

export default App;
